module.exports = "<div class=\"tab-stage {{themeClass}}\"> <ul class=tab-item-ul> <li v-for=\"item in items\" @click=select($index) class=item :class=\"{active: isActive($index)}\"> {{item.text}} </li> </ul> <div class=\"hide tab-items-slot\"></div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/common/components/base/tab/tab.tpl
// module id = 947
// module chunks = 2